export default __webpack_public_path__ + "static/media/deposit.f1f077fa.svg";